var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap pt-3"},[_c('div',{staticClass:"session-form-hold"},[_c('div',[_c('v-progress-linear',{attrs:{"active":_vm.loading,"indeterminate":_vm.loading,"absolute":"","top":"","color":"white"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }